@if (!(formVisible$ | async)) {
  <button
    type="button"
    (click)="formVisible$.next(true)"
    class="placeholder"
    translate
    >
    cljmyeorv000108l565b00amv
  </button>
}
@if (formVisible$ | async) {
  <div [formGroup]="model" class="form-container">
    <quill-editor
      (onEditorCreated)="created($event)"
      [modules]="modules"
    [placeholder]="
      'cljmye7dh000008l5ghi10i9g' | translate: 'orderManagement' | async
    "
      formControlName="comment"
    ></quill-editor>
    <div class="actions">
      <button
        type="button"
        class="commentActionButton commentActionButton--primary"
        (click)="submitComment()"
        [disabled]="model.invalid"
        >
        {{ 'add' | translate: 'common' | async }}
      </button>
      <button type="button" class="commentActionButton" (click)="discardDraft()">
        {{ 'cancel' | translate: 'common' | async }}
      </button>
    </div>
  </div>
}
